import { useState } from "react";

export default function GenerateButton({
  selectedTemplateIds = [],
  onGenerate,
  disabled = false,
}) {
  const [generating, setGenerating] = useState(false);

  const handleGenerate = async () => {
    if (selectedTemplateIds.length === 0 || disabled) return;

    try {
      setGenerating(true);
      await onGenerate();
    } finally {
      setGenerating(false);
    }
  };

  if (selectedTemplateIds.length === 0) {
    return null; // Don't show button if no templates selected
  }

  return (
    <div className="mt-3 px-4 pb-3 sm:pb-2 bg-gray-50 border-t border-gray-200 sm:rounded-b-md">
      <div className="flex justify-center mb-2">
        <button
          onClick={handleGenerate}
          disabled={disabled || generating}
          className="flex items-center justify-center gap-2 px-6 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors min-w-fit"
        >
          {generating ? (
            <>
              <svg
                className="animate-spin h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              <span>Generating...</span>
            </>
          ) : (
            <>
              {/* AI Icon */}
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
              <span>Generate ({selectedTemplateIds.length})</span>
            </>
          )}
        </button>
      </div>

      {/* Helper text */}
      <p className="text-center text-xs text-gray-500">
        AI will fill the selected templates with information from your
        transcript
      </p>
    </div>
  );
}
